<script setup>
import {onBeforeMount, reactive} from 'vue'
import {icons} from '@/paks/vu-theme'

const {modelValue: view} = defineProps({modelValue: Object})

const emit = defineEmits(['close'])

const page = reactive({
    icons: null,
    roles: null,
})

onBeforeMount(() => {
    // TODO - should come from display.roles || Roles
    page.roles = ['inherited', 'public', 'user', 'admin', 'owner']
    page.icons = Object.keys(icons)
        .map((i) => `$${i}`)
        .sort()
    page.hasTabs = Array.isArray(view.tabs)
})

function updateTabs(value) {
    if (value) {
        view.tabs = []
    } else {
        view.tabs = false
    }
}
</script>

<template>
    <div class="page-nav-edit">
        <vu-input
            v-model="view.path"
            label="Page URL"
            name="path"
            placeholder="Enter full URL Path"
            type="text"
            class="mb-2" />

        <vu-input
            v-model="view.name"
            label="Route name"
            name="name"
            placeholder="Optional symbolic route name"
            type="text"
            class="mb-2" />

        <vu-input
            v-model="view.title"
            label="Page Title"
            name="title"
            placeholder="Enter title"
            type="text"
            class="mb-2" />

        <vu-input
            v-model="view.menu"
            label="Sidebar Menu"
            name="menu"
            placeholder="Menu Text"
            type="text"
            class="mb-2" />

        <v-combobox
            class="vu-input vcol vcol-12"
            v-model="view.icon"
            :items="page.icons"
            bg-color=""
            :color="undefined"
            density="compact"
            variant="underlined"
            label="Menu Icon"
            placeholder="Enter icon name">
            <template v-slot:item="{item, props}">
                <v-list-item v-bind="props">
                    <template v-slot:prepend>
                        <v-icon size="small" color="primary" :icon="item.raw"></v-icon>
                    </template>
                </v-list-item>
            </template>
            <template v-slot:selection="{item}">
                <div>
                    <v-icon size="small" _color="primary" :icon="item.title"></v-icon>
                    <span class="ml-2">{{ item.title }}</span>
                </div>
            </template>
        </v-combobox>

        <vu-input label="Redirect" v-model="view.redirect" cols="6" type="text" placeholder="Optional redirect URL" />

        <vu-input label="Role" v-model="view.role" cols="6" type="select" :items="page.roles" />

        <div class="vrow">
            <vu-input
                label="Tab Navigation"
                v-model="page.hasTabs"
                cols="4"
                type="switch"
                @update:model-value="updateTabs" />
        </div>
    </div>
</template>

<style lang="scss">
.page-nav-edit {
    .v-select-list {
        padding: 0;
        border: solid 1px rgb(var(--v-theme-border-lighten-1));
        border-radius: 0;
    }
    h3 {
        font-weight: normal;
        color: rgb(var(--v-theme-text));
    }
    .v-list-item {
        min-height: 30px !important;
    }
    .v-list-item__content {
        padding: 6px 0 6px 0 !important;
    }
    .v-list {
        padding: 0;
    }
    .v-select__content {
        .v-list {
            background: rgb(var(--v-theme-background-lighten-1)) !important;
        }
    }
    margin-inline-start: 0 !important;
}
</style>

<style lang="scss" scoped>
.pick-items {
    font-size: 1rem;
}
.v-list-item {
    min-height: 30px !important;
}
.v-list-item__content {
    padding: 6px 0 6px 0 !important;
}
.v-list {
    padding: 0;
}
</style>
